export default __webpack_public_path__ + "static/media/BMWGroup-Regular.0a49beb9.woff";